export default class FocusableElements {
    #elements = [];

    #trapClassName;

    constructor(context = document, trapClassName = 'focus-trap') {
        this.#elements = [...context.querySelectorAll('button, a, input, textarea, select, area, [tabindex]')];
        this.#trapClassName = trapClassName;
    }

    get first() {
        if (this.#elements.length > 0) return this.#elements[0];
        return undefined;
    }

    get firstReal() {
        return this.#elements.find((elem) => !elem.classList.contains(this.#trapClassName));
    }

    get last() {
        if (this.#elements.length > 0) return this.#elements[this.#elements.length - 1];
        return undefined;
    }

    get lastReal() {
        return this.#elements.findLast((elem) => !elem.classList.contains(this.#trapClassName));
    }

    get all() {
        return this.#elements;
    }
}
